import _ from 'lodash';
import { UnderlyingPolicy} from 'gw-capability-quoteandbind';
import Vehicle from '../models/PUPVehicle';
import Contact from '../models/Contact';

let nextId;

const bindUnderlyingPolicyModel = (array = []) => {
    return _.map(array, (item) => {
        return new UnderlyingPolicy(item);
    }, this);
};

const bindVehicleModel = (array = []) => {
    return _.map(array, (item) => {
        return new Vehicle(item);
    }, this);
};

const bindContactModel = (array = []) => {
    return _.map(array, (item) => {
        return _.extend(item, {
            contact: new Contact(item.contact)
        });
    }, this);
};

const PUPPolicyChangeLobDataExtension = function (policyChange) {
    // eslint-disable-next-line prefer-destructuring
    nextId = policyChange.nextId;
    const data = policyChange.lobData.personalUmbrella;
    if (data && _.isObject(data)) {
        this.preQualQuestionSets = data.preQualQuestionSets;
        this.priorInsurance = data.priorInsurance;
        this.privacyDisclaimer = data.privacyDisclaimer;
        this.modifiers_ML = data.modifiers_ML;
        this.underlyingPolicies = bindUnderlyingPolicyModel(data.underlyingPolicies);
        this.coverables = {
            additionalInterests: data.coverables.additionalInterests || [],
            businessActivities: data.coverables.businessActivities,
            homeLosses_ML: data.coverables.homeLosses_ML || [],
            locations: data.coverables.locations,
            priorLosses_ML: data.priorLosses_ML,
            vehicleOperators: bindContactModel(data.coverables.vehicleOperators),
            availableInsuredCandidates_Ext: bindContactModel(data.coverables.availableInsuredCandidates_Ext),
            vehicles: bindVehicleModel(data.coverables.vehicles),
            watercraftOperators: bindContactModel(data.coverables.watercraftOperators),
            watercrafts: data.coverables.watercrafts,
            addInterestTypeCategory: data.coverables.addInterestTypeCategory
        };
        this.offerings = data.offerings;
    } else {
        this.underlyingPolicies = [];
        this.coverables = {
            additionalInterests: [],
            businessActivities: [],
            homeLosses_ML: [],
            locations: [],
            priorLosses_ML: [],
            vehicleOperators: [],
            availableInsuredCandidates_Ext: [],
            vehicles: [],
            watercraftOperators: [],
            watercrafts: []
        };
    }
};

PUPPolicyChangeLobDataExtension.prototype.beforeSave = function () {
    if (this.underlyingPolicies) {
        this.underlyingPolicies.forEach((ulPolicy) => {
            if (ulPolicy.ulPolicyFixID === 'new') {
                this.removeUnderlyingPolicy(ulPolicy);
            }
        });
    }
};

PUPPolicyChangeLobDataExtension.prototype.createUnderlyingPolicy = function (data) {
    const newUnderlyingPolicy = new UnderlyingPolicy(data);
    newUnderlyingPolicy.tempID = nextId();

    this.underlyingPolicies.push(newUnderlyingPolicy);

    return newUnderlyingPolicy;
};

PUPPolicyChangeLobDataExtension.prototype.removeUnderlyingPolicy = function (data) {
    const idx = _.indexOf(this.underlyingPolicies, data);
    if (idx >= 0) {
        this.underlyingPolicies.splice(idx, 1);
    }
};

PUPPolicyChangeLobDataExtension.prototype.createVehicle = function () {
    const v = new Vehicle({tempID: nextId()});
    v.isNew = true;
    this.coverables.vehicles.push(v);
    return v;
};

PUPPolicyChangeLobDataExtension.prototype.removeVehicle = function (vehicle) {
    const idx = _.indexOf(this.coverables.vehicles, vehicle);
    if (idx >= 0) {
        this.coverables.vehicles.splice(idx, 1);
    }
};

PUPPolicyChangeLobDataExtension.prototype.addVehicle = function (vehicle) {
    this.coverables.vehicles.push(vehicle);
};

export default PUPPolicyChangeLobDataExtension;
